import { render } from "./Textarea-Plus.vue?vue&type=template&id=6c2826ae&scoped=true"
import script from "./Textarea-Plus.vue?vue&type=script&lang=js"
export * from "./Textarea-Plus.vue?vue&type=script&lang=js"

import "./Textarea-Plus.vue?vue&type=style&index=0&id=6c2826ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2826ae"]])

export default __exports__